<template>
  <div class="rsvp-person-root">
    <div class="name-input">
      <input type="text"
             :value="value.name"
             @input="update('name', $event.target.value)"
             spellcheck="false"
             placeholder="Full Name"
      />
    </div>
    <p>Will you be attending?</p>
    <div class="rsvp-attending-group">
      <vue-radio :model-value="value.attending"
                 @change="update('attending', $event)"
                 :value="1"
                 type="border">
        Yes, I'll be there
      </vue-radio>
      <vue-radio :model-value="value.attending"
                 @change="update('attending', $event)"
                 :value="0"
                 type="border">
        Sorry, I can't make it
      </vue-radio>
    </div>
    <div :style="{ visibility: value.attending ? 'visible' : 'hidden' }">
      <p>Do you have any dietary requirements?</p>
      <p>
        <vue-checkbox-group :model-value="value.dietaryRequirements"
                            @change="update('dietaryRequirements', $event)"
                            class="rsvp-diet-group"
        >
          <vue-checkbox type="border" value="vegetarian">Vegetarian</vue-checkbox>
          <vue-checkbox type="border" value="other">Other</vue-checkbox>
        </vue-checkbox-group>
      </p>
      <div :style="{ visibility: otherSet ? 'inherit' : 'hidden' }">
        <p>If you have other dietary requirements, what are they?</p>
        <p>
          <vue-input :value="value.otherDiet"
                     @input="update('otherDiet', $event)"
                     placeholder="e.g. peanuts">
            <template slot="prepend">I cannot eat</template>
          </vue-input>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  const defaultValue = () => ({
    attending: 1,
    name: '',
    dietaryRequirements: [],
    otherDiet: '',
  })

  export default {
    name: 'RSVPPerson',
    props: {
      value: {
        type: Object,
        default() {
          return { ...defaultValue() }
        },
      },
    },
    methods: {
      update(key, event) {
        this.$emit('input', {
          ...this.value,
          [key]: event,
        })
      },
    },
    computed: {
      otherSet() {
        return this.value.dietaryRequirements.includes('other')
      },
    },
    created() {
      this.$emit('input', {
        ...defaultValue(),
        ...this.value,
      })
    },
  }
</script>

<style scoped lang="scss">
  .name-input {
    input {
      border: none;
      border-radius: 0;
      padding-bottom: 1em;
      border-bottom: 1px solid var(--border-color);
      text-align: center;
      width: 100%;
      outline: none;
      font-size: 16px;
      font-weight: 100;
      font-family: 'Crimson Text', serif;
      color: var(--text-color-main);

      &::placeholder {
        color: var(--text-color-unpop);
        opacity: 1;
      }
      &:focus::placeholder {
        opacity: 0.1;
      }
    }
  }

  .rsvp-person-root {
    --border-color: hsl(var(--text-hue), 20%, 80%);
    box-sizing: border-box;
    text-align: justify;
    border: 1px solid var(--border-color);
    border-radius: 2px;
    padding: 1em;
    margin-bottom: 1em;
    max-width: 30em;
    min-width: 20em;
    flex-basis: 20em;
    flex-shrink: 1;
  }

  .rsvp-diet-group {
    display: grid;
    width: 100%;
    grid-template-columns: 50% 50%;

    & > div {
      display: flex;
      justify-content: center;
      margin-left: 0;
      white-space: nowrap;

    }
  }

  .rsvp-attending-group {
    box-sizing: border-box;
    width: 100%;
    text-align: center;

    label {
      box-sizing: border-box;
      white-space: nowrap;
      text-align: center;
      width: 50%;
      overflow: hidden;
      text-overflow: ellipsis;
      position: relative;
      border-radius: 0;
      margin-left: 0 !important;
      margin-right: -1px;

      &:first-child {
        border-bottom-left-radius: 4px;
        border-top-left-radius: 4px;
      }

      &:last-child {
        border-bottom-right-radius: 4px;
        border-top-right-radius: 4px;
      }

      &.vue-radio--checked {
        z-index: 100;
      }

    }
  }

</style>

<style lang="scss">
  .vue-checkbox--bordered {
    transition-property: border, color !important;
    transition-duration: .2s;
  }

  .rsvp-diet-group {
    div .vue-checkbox {
      border-radius: 0;
      z-index: 1;
    }

    div {
      &:nth-child(1) .vue-checkbox {
        border-top-left-radius: 4px;
        margin-right: -1px;
        &.vue-checkbox--checked {
          z-index: 2;
        }
      }
      &:nth-child(2) .vue-checkbox {
        border-top-right-radius: 4px;
        margin-left: -1px;
        &.vue-checkbox--checked {
          z-index: 2;
        }
      }
      &:nth-child(3) .vue-checkbox {
        border-bottom-left-radius: 4px;
        margin-right: -1px;
        margin-top: -1px;
        &.vue-checkbox--checked {
          z-index: 2;
        }
      }
      &:nth-child(4) .vue-checkbox {
        border-bottom-right-radius: 4px;
        margin-left: -1px;
        margin-top: -1px;
        &.vue-checkbox--checked {
          z-index: 2;
        }
      }
    }
    .vue-checkbox {
      width: 100%;
      box-sizing: border-box;

    }
  }
</style>
